import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { comics } from "@/mocks/comics";

export default function CategoryQuickLinks() {
  return (
    <section className="w-full px-4 md:px-8 py-10 md:py-14">
      <div className="flex items-end justify-between gap-4 mb-7">
        <div>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            热门分类快捷入口
          </h2>
          <p className="text-sm text-foreground-500 mt-2">
            按题材快速找到你想看的韩漫，爱情、奇幻、悬疑、校园一网打尽
          </p>
        </div>
        <Link
          to="/category"
          className="hidden sm:inline-flex items-center gap-1 text-sm text-accent-600 hover:text-accent-700 whitespace-nowrap"
        >
          全部分类
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
        {categories.map((category) => {
          const count = comics.filter((item) => item.category === category.id).length;
          return (
            <Link
              key={category.id}
              to={`/category?cat=${category.id}`}
              className="group flex items-center gap-3 p-4 rounded-lg bg-background-100 border border-background-200 hover:border-accent-300 transition-colors cursor-pointer"
            >
              <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-md bg-accent-100 text-accent-700 text-2xl group-hover:bg-accent-500 group-hover:text-white transition-colors">
                <i className={category.icon}></i>
              </span>
              <span className="flex flex-col min-w-0">
                <span className="font-heading font-semibold text-sm md:text-base text-foreground-950 whitespace-nowrap">
                  {category.name}
                </span>
                <span className="text-xs text-foreground-500 truncate">
                  {count} 部作品
                </span>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}